module.exports = __webpack_public_path__ + "files/ff5a93530902a77d9fbdb2ab835781f4.svg";